import { DragWidgetServiceBase } from './drag.widget.service.base';

export class IntercomDragWidgetService extends DragWidgetServiceBase {
    public override loadElements() {
        try {
            const intercom = document.querySelector(".intercom-app");
            if (!intercom) {
                this.beginMoving();
                return
            }

            this.messengerContainerElem = intercom.querySelector("div.intercom-messenger-frame");
            this.frameElem = intercom.querySelector("iframe[name='intercom-messenger-frame']");

            if (!this.messengerContainerElem || !this.frameElem) {
                this.beginMoving();
            }
        } catch (error) {
            console.log(error);
            this.beginMoving();
        }
    }
}